import { myAxios } from "./axios";

export function getHourCollections(payload, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(payload || {}),
    },
  };
  return myAxios.get("/hours-collections", config);
}
